import { render, staticRenderFns } from "./AtestadoSuccess.vue?vue&type=template&id=5cf85d4d&scoped=true&"
import script from "./AtestadoSuccess.vue?vue&type=script&lang=js&"
export * from "./AtestadoSuccess.vue?vue&type=script&lang=js&"
import style0 from "./AtestadoSuccess.vue?vue&type=style&index=0&id=5cf85d4d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf85d4d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
